import React, { useState } from "react";
import StatusPill from "../../../../components/data-table/StatusPill";
import RowActions from "../../../../components/data-table/RowActions";
import toast from "react-hot-toast";

// components
import { useDeleteDisplayMutation } from "../../../../store/Reducer/display";
import DeleteModal from "../../../../components/confirm-dialog/delete-modal";
import MessageModal from "../../../../components/Modal/message-modal";
import AttachPlayList from "../components/attach-playlist";

export default function TableBodyCustom({ data, index, onEditRow }) {

  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [messageModal, setMessageModal] = useState(false);

  const [deleteDisplay, { isLoading: isDeleting }] = useDeleteDisplayMutation();
  const [isAttach, setIsAttach] = useState(false);
  const [deviceId, setDeviceId] = useState(null);

  const openModal = (id) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);
  const openMessageModal = () => setMessageModal(true);
  const closeMessageModal = () => setMessageModal(false);

  const handleDelete = async () => {
    if (selectedId) {
      try {
        await deleteDisplay(selectedId).unwrap();
        closeModal();
      } catch (error) {
        console.error("Failed to delete display:", error);
        toast.error(error?.data?.message || "Failed to delete display.");
      }
    }
  };

  const openAttachModal = () => {
    setIsAttach(true);
  };

  const closeAttachModal = () => {
    setIsAttach(false);
  };

  return (
    <>
      <tr className="hover:bg-gray-50">
        <td className="px-4 py-3 font-medium text-gray-900">{data?.deviceName}</td>
        <td className="px-4 py-3">
          {data?.colorCode ? <span className="inline-flex items-center gap-2"><span className="h-4 w-4 rounded border border-gray-300" style={{ backgroundColor: data.colorCode }} aria-hidden="true" /><span className="font-mono text-xs text-gray-600">{data.colorCode}</span></span> : <span className="text-gray-400">—</span>}
        </td>
        <td className="px-4 py-3 capitalize text-gray-600">{data?.screenOrientation || "—"}</td>
        <td className="px-4 py-3">
          {data?.isActive === false ? <StatusPill tone="gray">Inactive</StatusPill> : <StatusPill tone="green">Active</StatusPill>}
        </td>
        <td className="px-4 py-3">
          <button
            type="button"
            onClick={() => {
              if (data?.deviceId) setDeviceId(data.deviceId);
              setIsAttach(true);
            }}
            className="whitespace-nowrap rounded-lg border border-blue-200 bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-700 hover:bg-blue-100"
          >
            Attach playlist
          </button>
        </td>
        <td className="px-4 py-3">
          <RowActions onEdit={() => onEditRow(data)} onDelete={() => openModal(data?._id)} editLabel="Edit display" deleteLabel="Delete display" />
        </td>
      </tr>

      <DeleteModal
        isOpen={isOpen}
        title="Are You Sure?"
        desc="This action will remove the event."
        onConfirm={handleDelete}
        onCancel={closeModal}
        isLoading={isDeleting}
      />

      <MessageModal
        isOpen={messageModal}
        data={data?.details}
        title="Message"
        onConfirm={handleDelete}
        onCancel={closeMessageModal}
      />

      <AttachPlayList
        isOpen={isAttach}
        closeModal={closeAttachModal}
        deviceId={deviceId}
      />
    </>
  );
}
